<template>
  <div>
    <component v-bind:is="this.currentComponent">
    </component>
    <div class="ctaWrapper">
      <ChoiceConfirm
        v-bind:disabled="this.$store.getters.onboardingNextDisabled(this.step)"
        v-on:click="increment">
        NEXT
      </ChoiceConfirm>
    </div>
  </div>
</template>

<script>
import Question1 from './Question'
import Question2 from './Question2'
import Question3 from './Question3'

export default {
  data() {
    return {
      step: 0,
      currentComponent: Question1,
      components: [Question1, Question2, Question3],
      disabled: false
    }
  },
  methods: {
    increment() {
      if (this.step === this.components.length - 1) {
        this.setPreference()
        return
      }

      this.step = this.step + 1
      this.currentComponent = this.components[this.step]
      window.scroll(0,0)
    },
    setPreference() {
      this.$store.commit('setPreference', this.$store.state.preference)
    },
    canProceed() {
      return false;
    }
  }
}
</script>
<style scoped>
.ctaWrapper{
  padding-right: 10vw;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/onboarding/OnboardingView.vue